export default __webpack_public_path__ + "static/media/contact.60660a52.png";